import { gql, useMutation } from '@apollo/client';

// GraphQL mutation
const DELETE_NOTE_ATTACHMENT_MUTATION = gql`
  mutation DeleteNoteAttachment($attachmentUuid: String!) {
    deleteAttachment(attachmentUuid: $attachmentUuid) {
      result
      nodesDeleted
      relationshipsDeleted
    }
  }
`;

export function DeleteNoteAttachment() {
  const [DeleteAttachment, { data, loading, error, reset }] = useMutation(
    DELETE_NOTE_ATTACHMENT_MUTATION
  );

  return {
    data,
    DeleteAttachment,
    loading,
    error,
    reset,
  };
}
